<template>
  <transition name="slide-fade">
    <div class="loading-data" v-if="loading">
      <i class="el-icon-loading"></i>
      <div>加载中，请稍后···</div>
    </div>
    <div class="look-detail-view" v-if="hide && !loading">
      <div class="look-nav">
        <div class="handle-wrapper" @click="backPath"><div class="icon-font">&#xe612;</div>返回</div>
        <div class="look-nav-center">损耗详情</div>
        <div class="handle-wrapper" style="opacity: 0"><div class="icon-font">&#xe612;</div>返回</div>
      </div>
      <div class="look-detail-view-content">
        <div class="look-detail-view-list">
          <div class="input-contain">
            <div class="input-title" style="padding-left: 0.89vw">批次号：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.batch" placeholder=""/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">烟叶简称：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.materialName" placeholder=""/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title">仓库位置：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.siteName" placeholder=""/>
            </div>
          </div>
          <div class="input-contain">
            <div class="input-title" style="padding-left: 1.78vw">日期：</div>
            <div class="input-wrapper" style="margin-right: 0">
              <input disabled="true" v-model="inputValue.createdTime" placeholder=""/>
            </div>
          </div>
        </div>
        <div class="look-detail-view-list">
          <div class="input-contain">
            <div class="input-title">损耗类型：</div>
            <div class="input-wrapper">
              <input disabled="true" placeholder="" v-model="inputValue.lossType.displayName"/>
            </div>
          </div>
        </div>
        <div class="look-detail-view-list">
          <div class="input-contain">
            <div class="input-title">损耗重量：</div>
            <div class="input-wrapper">
              <input disabled="true" v-model="inputValue.lossWeight" placeholder=""/>
            </div>
          </div>
        </div>
        <div class="text-area-wrapper" style="margin-bottom: 1vw">
          <div class="text-area-title">损耗原因：</div>
          <textarea disabled v-model="inputValue.lossReson" class="text-area-input"></textarea>
        </div>
        <div class="text-area-wrapper">
          <div class="text-area-title" style="padding-left: 1.78vw">备注：</div>
          <textarea disabled v-model="inputValue.remark" class="text-area-input"></textarea>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import localforage from 'localforage'
export default {
  name: 'LookDetailView',
  data () {
    return {
      loading: true,
      hide: false,
      inputValue: ''
    }
  },
  created () {
    let _this = this
    setInterval(function () {
      _this.hide = true
    }, 100)
    localforage.getItem('lossInfo').then(res => {
      console.log(res)
      _this.inputValue = res
      _this.loading = false
    })
  },
  methods: {
    backPath: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
@import "./Loss.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/loss/LookDetailView.vue